import { SignupActions } from './SignupActions'
import { DetailsStep } from './DetailsStep'
import { EmailStep } from './EmailStep'
import { SignupProgress } from './SignupProgress'
import { SignupSuccess } from './SignupSuccess'
import {
  type SignupStatus,
  type UpdateFormValue,
  type WaitlistFormData
} from './types'

interface SignupFlowProps {
  step: number
  status: SignupStatus
  formData: WaitlistFormData
  error: string
  onBack: () => void
  onSaveEmail: () => void
  onSubmit: () => void
  onChange: UpdateFormValue
}

export function SignupFlow({
  step,
  status,
  formData,
  error,
  onBack,
  onSaveEmail,
  onSubmit,
  onChange
}: SignupFlowProps) {
  if (status === 'success') return <SignupSuccess email={formData.email} />

  const saving =
    step === 0 ? status === 'saving-email' : status === 'submitting'
  return (
    <section className="waitlist" id="signup" aria-label="Class signup">
      <SignupProgress step={step} />
      {step === 0 ? (
        <EmailStep
          value={formData.email}
          onChange={(value) => onChange(value, 'email')}
        />
      ) : (
        <DetailsStep formData={formData} onChange={onChange} />
      )}
      <SignupActions
        isFirstStep={step === 0}
        saving={saving}
        onBack={onBack}
        onContinue={step === 0 ? onSaveEmail : onSubmit}
      />
      <p className={error ? 'form-note error' : 'form-note'}>
        {error || 'No spam. Just one good email when we launch.'}
      </p>
      <a className="pricing-note" href="/pricing">
        Pricing coming soon
      </a>
    </section>
  )
}
